import LegalClause from './LegalClause';
import { BUSINESS, telHref } from '../../constants/businessDetails';

/**
 * Contact Us body content — rendered by the /contact page and by the
 * homepage's Trust Center tab. Required by Razorpay of every merchant site.
 * Names the registered business exactly as on its GST certificate. The
 * addresses and the two phone numbers are the owner's (2026-11-03).
 */

const WRITE_TO: [string, string][] = [
  ['General enquiries', BUSINESS.contactEmail],
  ['Support', BUSINESS.supportEmail],
  ['Billing, payments and refunds', BUSINESS.accountsEmail],
  ['Legal', BUSINESS.legalEmail],
  ['Grievance Officer', BUSINESS.grievanceEmail],
];

const LINK = 'underline font-medium text-text-primary';

/** The page's overline and title, shared by /contact and the homepage tab. */
export const CONTACT_HEADING = { overline: 'Contact', title: 'Contact Us' } as const;

export default function ContactContent() {
  return (
    <>
      <LegalClause id="c1" n="1" title="Write to us">
        {WRITE_TO.map(([label, email]) => (
          <p key={email}>
            {label}:{' '}
            <a href={`mailto:${email}`} className={LINK}>
              {email}
            </a>
          </p>
        ))}
        <p>We reply within two working days.</p>
      </LegalClause>

      <LegalClause id="c2" n="2" title="Call us">
        {BUSINESS.phones.map((phone) => (
          <p key={phone}>
            <a href={telHref(phone)} className={LINK}>
              {phone}
            </a>
          </p>
        ))}
      </LegalClause>

      <LegalClause id="c3" n="3" title="Registered business">
        <p>
          {BUSINESS.brand} ({BUSINESS.website}) is operated by:
        </p>
        <address className="not-italic text-text-primary leading-relaxed">
          <strong>{BUSINESS.legalName}</strong>
          <br />
          {BUSINESS.addressLines.map((line) => (
            <span key={line}>
              {line}
              <br />
            </span>
          ))}
          GSTIN: {BUSINESS.gstin}
        </address>
      </LegalClause>
    </>
  );
}
